import { useContext, useCallback } from "react"

import { CursorContext } from "../context/cursor/context"
import isTouchDevice from "../utils/is_touch_device"

const useCursorHandlers = (options = {}) => {
    const [, setCursor] = useContext(CursorContext)

    const toggleCursor = useCallback(() =>
        setCursor(({ active }) => ({ active: !active })), [setCursor])

    const onMouseEnter = useCallback(event => {
        if (options.onMouseEnter) options.onMouseEnter(event)

        toggleCursor()
    }, [options, toggleCursor])

    const onMouseLeave = useCallback(event => {
        if (options.onMouseLeave) options.onMouseLeave(event)

        toggleCursor()
    }, [options, toggleCursor])

    if (isTouchDevice) return options

    return { onMouseEnter, onMouseLeave }
}

export default useCursorHandlers